import Accepted from './Accepted'
import './Accepted.css'

export default Accepted


// WEBPACK FOOTER //
// ./src/features/OrderDetails/components/Accepted/index.js